import classnames from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import React from 'react';

type Props = {
  slug: string;
};

const SupportSidebar = ({ slug }: Props) => {
  const { t } = useTranslation('support');
  const navData = [
    { link: '/support/contact', title: t('contactUs') },
    { link: '/support/faq', title: t('faq') },
    { link: '/support/releases', title: t('releases') },
    { link: '/support/allocation', title: t('allocation') },
    { link: '/support/shipping', title: t('ordersShipping') },
    { link: '/support/returns', title: t('returnsRefund') },
    { link: '/support/nfts', title: t('nfts') },
    { link: '/support/terms-and-conditions', title: t('termsConditions') },
    { link: '/support/terms-of-use', title: t('termsOfUse') },
    { link: '/support/conditions-of-sale', title: t('conditionsOfSale') },
    { link: '/support/aml-policy', title: t('amlPolicy') },
    { link: '/support/privacy-policy', title: t('privacyPolicy') },
    { link: '/support/cookie-policy', title: t('cookiePolicy') },
  ];

  return (
    <section className="col-span-12 hidden space-y-3 md:col-span-4 md:block lg:col-span-3">
      <div className="w-full">
        <p className="text-md font-bold md:text-lg">{t('sideBarTitle')}</p>
      </div>
      <nav className="crumbs w-full py-4">
        <ul>
          {navData.map(({ link, title }, index) => (
            <li key={index} className="pb-2">
              <Link
                className={classnames(
                  {
                    'text-neutral-4': link.includes(slug),
                  },
                  'hover:text-neutral-4',
                )}
                href={link}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
};

export default SupportSidebar;
